import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mobileConfigurationTitle: {
    description: 'Title for the mobile configuration section',
    defaultMessage: 'Mobile Configuration',
    id: 'KUQ+KJ',
  },
  defaultQuantityOfTotes: {
    description: 'Label for default quantity of totes setting',
    defaultMessage: 'Default quantity of totes',
    id: 'ooRGNO',
  },
  defaultQuantityDescription: {
    description: 'Description for default quantity of totes setting',
    defaultMessage: 'This only applies to Multi-item Order Picking.',
    id: '2yYubt',
  },
  showLocationStep: {
    description: 'Label for show location step setting',
    defaultMessage: 'Show location step',
    id: 'eb0yXE',
  },
  showLocationStepDescription: {
    description: 'Description for show location step setting',
    defaultMessage: 'Pickers will be shown the location of the product needed to be picked in a dedicated step.',
    id: 'AVVein',
  },
  requireLocationVerification: {
    description: 'Label for require location scan setting',
    defaultMessage: 'Require location scan',
    id: 'XlMvRB',
  },
  requireLocationVerificationDescription: {
    description: 'Description for require location scan setting',
    defaultMessage: 'Pickers will scan the barcode on the bin to verify they are picking from the correct location.',
    id: 'XsdVAo',
  },
  sortItemsBy: {
    description: 'Label for sort items by setting',
    defaultMessage: 'Sort items to pick by:',
    id: 'ZnxxRd',
  },
  sortByLocation: {
    description: 'Sort option for sorting by location',
    defaultMessage: 'Location',
    id: 'ah5rwu',
  },
  sortBySKU: {
    description: 'Sort option for sorting by SKU',
    defaultMessage: 'SKU',
    id: 'haD9fB',
  },
  sortByQuantity: {
    description: 'Sort option for sorting by Quantity',
    defaultMessage: 'Quantity',
    id: 'Iyq4p9',
  },
  sortByName: {
    description: 'Sort option for sorting by Name',
    defaultMessage: 'Name',
    id: 'B9oEL+',
  },
});
